import React from 'react';

import classnames from 'classnames';
import { ArrowRight } from 'lucide-react';

import { demoLink, registerLink } from 'common/routeComponents/landing/core/constants';
import ButtonLink from 'common/uiV3/Button/ButtonLink';
import nbspLastSpace from 'common/util/nbspLastSpace';

import 'css/components/www/LandingV3/_LandingCTA.scss';

type Copy = {
  title: string;
  subtitle?: string;
  demoButton: string;
  registerButton: string;
};

export type Props = {
  copy: Copy;
  registerLinkOverride?: string;
  demoLinkOverride?: string;
  orientation?: 'vertical' | 'horizontal';
  className?: string;
  style?: React.CSSProperties;
};

const LandingCTA = ({
  copy: { title, subtitle, demoButton, registerButton },
  registerLinkOverride = registerLink,
  demoLinkOverride = demoLink,
  orientation = 'horizontal',
  className,
  style,
}: Props) => {
  return (
    <section
      className={classnames('LandingCTA', `LandingCTA--${orientation}`, className)}
      style={style}>
      <h2 className="LandingCTA__title">{nbspLastSpace(title)}</h2>
      {subtitle ? <p className="LandingCTA__subtitle">{nbspLastSpace(subtitle)}</p> : null}
      <div className="LandingCTA__links">
        <ButtonLink
          to={demoLinkOverride}
          size="xlarge"
          variant="outlined"
          responsive
          className="w-full sm:flex-1">
          {demoButton}
        </ButtonLink>
        <ButtonLink to={registerLinkOverride} size="xlarge" responsive className="w-full sm:flex-1">
          {registerButton}
          <ArrowRight />
        </ButtonLink>
      </div>
    </section>
  );
};

export default LandingCTA;
